import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VMain,{staticClass:"min-vh-100"},[_c(VContainer,{staticClass:"pa-0",attrs:{"fluid":""}},[(_vm.show2fa)?_c('two-factor-authentication'):_c('router-view'),_c('loader',{attrs:{"value":_vm.isLoading}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }